import { ParsedUrlQuery, stringify } from 'querystring';

import { SearchParameters, SearchResultType } from '@ms/yammer-data/dist/state/types';

import { searchPathPublisherQuestions, searchPathQuestions } from './questions';

export const searchPathThreads = '/search/threads';
export const searchPathGroups = '/search/groups';
export const searchPathUsers = '/search/users';
export const searchPathFiles = '/search/files';
export const searchPathInbox = '/search/inbox';
export const searchPathTopics = '/search/topics';

export const searchQueryTextKey = 'search';
export const searchQueryGroupScopeKey = 'groupScope';
export const searchQueryStartDateKey = 'start';
export const searchQueryEndDateKey = 'end';
export const searchQueryTypeKey = 'type';
export const searchQueryTypeInboxValue = 'inbox';

const paths: Record<SearchResultType, string> = {
  [SearchResultType.Thread]: searchPathThreads,
  [SearchResultType.Group]: searchPathGroups,
  [SearchResultType.User]: searchPathUsers,
  [SearchResultType.File]: searchPathFiles,
  [SearchResultType.Inbox]: searchPathInbox,
  [SearchResultType.Topic]: searchPathTopics,
  [SearchResultType.NetworkQuestion]: searchPathQuestions,
  [SearchResultType.PublisherNetworkQuestion]: searchPathPublisherQuestions,
};
type SearchPageWithParameters = (searchParameters: SearchParameters) => string;

export const searchPageWithParameters: SearchPageWithParameters = (searchParameters) => {
  const queryParameters = makeSearchQueryStringParameters(searchParameters);

  return `${paths[searchParameters.resultType]}?${stringify(queryParameters as unknown as ParsedUrlQuery)}`;
};

export const searchPageVivaAnswers = (query: string): string => {
  const queryParameters = {
    search: query.trim(),
  };

  return `${searchPathQuestions}?${stringify(queryParameters)}`;
};

export interface SearchQueryParameters {
  readonly [searchQueryTextKey]: string;
  readonly [searchQueryGroupScopeKey]?: string;
  readonly [searchQueryTypeKey]?: string;
  readonly [searchQueryStartDateKey]?: number;
  readonly [searchQueryEndDateKey]?: number;
}

type MakeQueryObjectWithSearchParameters = (searchParameters: SearchParameters) => SearchQueryParameters;

export const makeSearchQueryStringParameters: MakeQueryObjectWithSearchParameters = ({
  resultType,
  searchText,
  groupScope,
  startTimestamp,
  endTimestamp,
}) => {
  const searchTextParameter = { [searchQueryTextKey]: searchText };
  const scopeParameter = groupScope ? { [searchQueryGroupScopeKey]: groupScope } : {};
  const typeParameter =
    resultType === SearchResultType.Inbox ? { [searchQueryTypeKey]: searchQueryTypeInboxValue } : {};
  const startTimestampParameter = startTimestamp ? { [searchQueryStartDateKey]: startTimestamp } : {};
  const endTimestampParameter = endTimestamp ? { [searchQueryEndDateKey]: endTimestamp } : {};

  return {
    ...searchTextParameter,
    ...scopeParameter,
    ...typeParameter,
    ...startTimestampParameter,
    ...endTimestampParameter,
  };
};
